import produce from 'immer';
import { put, takeLatest } from 'redux-saga/effects';
import { creator, errorMessageGenerator } from 'uwork-app-core';
import axios from 'utils/axios';

/**
 * External Ations
 */

/**
 * Constants
 */
export const REQUEST = '@app/general/zipcodes/REQUEST';
export const SUCCESS = '@app/general/zipcodes/SUCCESS';
export const FAILURE = '@app/general/zipcodes/FAILURE';
export const CLEAR = '@app/general/zipcodes/CLEAR';

/**
 * Initial state
 */
const initState = {
    loading: false,
    errorStatus: '',
    data: null
};

/**
 * Defualt reducer
 *
 * @param state
 * @param action
 */
const reducer = (state = initState, { payload, ...action }) =>
    produce(state, (draft) => {
        switch (action.type) {
            case REQUEST:
                draft.loading = true;
                draft.errorStatus = '';
                break;
            case FAILURE:
                draft.errorStatus = payload;
                draft.loading = false;
                draft.data = null;
                break;
            case SUCCESS:
                draft.data = payload;
                draft.loading = false;
                break;
            case CLEAR:
                draft.data = null;
                draft.loading = false;
                draft.errorStatus = '';
                break;
            default:
                break;
        }
    });
export default reducer;

/**
 * Redux actions
 */
export const actions = {
    request: (data) => creator(REQUEST, data),
    success: (data) => creator(SUCCESS, data),
    failure: (data) => creator(FAILURE, data),
    clear: () => creator(CLEAR)
};

/**
 * Saga functions
 */
export const sagas = {
    *request({ payload }) {
        try {
            const response = yield axios.get(`/zipcodes?zipcode=${payload}`);
            yield put(actions.success({ city: response.data, zipcode: payload }));
        } catch (e) {
            yield put(actions.failure(errorMessageGenerator(e)));
        }
    }
};

/**
 * Saga watchers
 */
export const watcher = function* watch() {
    yield takeLatest(REQUEST, sagas.request);
};
